'use client';

import React from 'react';
import { motion } from 'framer-motion';

interface NavigationBarProps {
  sections: string[];
  activeSection: number;
  onNavigate: (index: number) => void;
  actionButton?: React.ReactNode;
}

export function NavigationBar({
  sections,
  activeSection,
  onNavigate,
  actionButton
}: NavigationBarProps) {
  // Function to get display name for sections
  const getDisplayName = (sectionId: string) => {
    const displayNames: {
      [key: string]: string;
    } = {
      overview: 'Ingredients',
      formulation: 'Talk to a Chemist',
      partnership: 'Partner Portal'
    };
    return displayNames[sectionId] || sectionId.charAt(0).toUpperCase() + sectionId.slice(1);
  };

  return (
    <motion.div
      className="flex items-center gap-3"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{
        duration: 0.5,
        type: 'spring',
        stiffness: 100,
        damping: 20
      }}
    >
      <div className="inline-flex items-center gap-2 p-1.5 backdrop-blur-xl bg-white/[0.02] border border-white/10 rounded-full shadow-elev-1">
        {sections.map((section, index) => {
          const isActive = activeSection === index;
          return (
            <motion.button
              key={section}
              onClick={() => onNavigate(index)}
              className={`
                ${isActive
                  ? 'bg-gradient-to-r from-eskerium-blue/20 to-eskerium-blue/10 border border-eskerium-blue/50 text-white'
                  : 'text-white/60 hover:text-white'
                }
                rounded-full px-4 py-2 transition-all duration-300 ease-gentle relative text-sm font-medium
              `}
              whileHover={{ scale: isActive ? 1 : 1.05 }}
              whileTap={{ scale: 0.95 }}
              transition={{
                type: 'spring',
                stiffness: 400,
                damping: 17
              }}
            >
              <span className={`relative z-10 ${isActive ? 'drop-shadow-sm' : ''}`}>
                {getDisplayName(section)}
              </span>
            </motion.button>
          );
        })}
      </div>
      {actionButton && <div>{actionButton}</div>}
    </motion.div>
  );
}